import type { FC, ReactNode } from 'react'

interface TreeRingsProps {
    className?: string
}

const RINGS = [
    { cx: 200, cy: 204, rx: 22, ry: 18 },
    { cx: 198, cy: 206, rx: 44, ry: 37 },
    { cx: 201, cy: 203, rx: 68, ry: 58 },
    { cx: 197, cy: 207, rx: 94, ry: 80 },
    { cx: 202, cy: 202, rx: 121, ry: 104 },
    { cx: 196, cy: 208, rx: 150, ry: 129 },
    { cx: 203, cy: 201, rx: 180, ry: 156 },
    { cx: 195, cy: 209, rx: 212, ry: 184 },
    { cx: 204, cy: 200, rx: 246, ry: 214 }
]

export const TreeRings: FC<TreeRingsProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 400 400'
            fill='none'
            stroke='currentColor'
            strokeWidth={1.2}
            aria-hidden='true'
            className={className}
        >
            {RINGS.map(ring => (
                <ellipse
                    key={`${ring.rx}-${ring.ry}`}
                    cx={ring.cx}
                    cy={ring.cy}
                    rx={ring.rx}
                    ry={ring.ry}
                    transform={`rotate(-12 ${ring.cx} ${ring.cy})`}
                />
            ))}
        </svg>
    )
}
